import React from 'react';
import { Home, Receipt, MapPin, Coffee, User } from 'lucide-react';

export type NavTabId = 'home' | 'pesanan' | 'outlet' | 'menu' | 'akun';

interface BottomNavProps {
  activeTab: NavTabId;
  onChangeTab: (tab: NavTabId) => void;
}

export const BottomNav: React.FC<BottomNavProps> = ({ activeTab, onChangeTab }) => {
  const navItems: { id: NavTabId; label: string; icon: React.ComponentType<{ className?: string }> }[] = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'pesanan', label: 'Pesanan', icon: Receipt },
    { id: 'outlet', label: 'Outlet', icon: MapPin },
    { id: 'menu', label: 'Menu', icon: Coffee },
    { id: 'akun', label: 'Akun', icon: User },
  ];

  return (
    <nav
      id="bottom-nav"
      aria-label="Mobile Bottom Navigation"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[#E2E8F0] px-4 py-2 shadow-[0_-4px_12px_rgba(0,0,0,0.03)] select-none pointer-events-auto"
      style={{
        paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom, 0px))',
      }}
    >
      <div className="max-w-lg mx-auto flex justify-between items-center">
        {navItems.map((item) => {
          const isActive = activeTab === item.id;
          const IconComponent = item.icon;

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onChangeTab(item.id)}
              className={`flex flex-col items-center gap-1 px-3 py-0.5 transition-colors cursor-pointer whitespace-nowrap ${
                isActive ? 'text-[#0056D2]' : 'text-slate-400 hover:text-[#0A192F]'
              }`}
            >
              <IconComponent
                className={`w-5 h-5 ${
                  isActive ? 'text-[#0056D2] stroke-[2.3]' : 'text-slate-400 stroke-[1.9]'
                }`}
              />
              <span
                className={`text-[10px] leading-tight ${
                  isActive ? 'font-bold text-[#0056D2]' : 'font-medium text-slate-400'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
